import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CmsItemConfiguration } from '../models/cms-item-configuration.class';
import { CmsItem } from '../models/cms-item.class';

import { CmsCollectionEnum } from '../models/cms-collection.enum';

import { CmsService } from './cms.service';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CmsDirectService {
  // apiUrl
  private apiUrl: string = environment.api.cms.url;

  /**
   * constructor
   *
   */
  constructor(
    private http: HttpClient,
    private cmsService: CmsService,
  ) {}

  /**
   * getConfiguration
   *
   */
  getConfiguration(): Observable<CmsItemConfiguration> {
    const collection = CmsCollectionEnum.Configuration;

    return this.http
      .get<
        CmsItem[]
      >(this.getUrl(collection), { headers: { skipToken: 'true' } })
      .pipe(
        map((res: any) =>
          this.cmsService.getService(collection).transformHttpResponse(res),
        ),
        filter((items) => items?.length > 0),
        map((items) => items[0]),
      );
  }

  /**
   * getUrl
   *
   */
  private getUrl(collection: CmsCollectionEnum, fields = '*.*'): any {
    const url = `${this.apiUrl}/items/${collection.toLowerCase()}?fields=${fields}`;

    return url;
  }
}
